module.exports = __webpack_public_path__ + "static/media/link.e44a2787.svg";